import { Avatar as ChakraAvatar, type AvatarRootProps } from "@chakra-ui/react";

import { asSlotComponent } from "../internal/v3-slot";

const AvatarRoot = asSlotComponent(ChakraAvatar.Root);
const AvatarImage = asSlotComponent(ChakraAvatar.Image);
const AvatarFallback = asSlotComponent(ChakraAvatar.Fallback);

export type AvatarProps = AvatarRootProps & {
  name?: string;
  src?: string;
};

function Avatar({ name, src, ...props }: AvatarProps) {
  return (
    <AvatarRoot {...props}>
      {src ? <AvatarImage src={src} alt={name} /> : null}
      <AvatarFallback name={name} />
    </AvatarRoot>
  );
}

export { Avatar };
